<template>
  <div>
    <!-- CONTENT -->
    <!--begin::Navbar-->
    <div class="card mb-5 mb-xl-10">
      <div class="card-body pt-0 pb-0">
        <!--begin::Navs-->
        <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
          <!--begin::Nav item-->
          <li class="nav-item mt-2">
            <a
              class="nav-link text-active-primary ms-0 me-10 py-5"
              :class="{
                active: currentTab === 'details'
              }"
              href="#"
              @click.prevent="changeTab('details')"
            >
              Detalhes
            </a>
          </li>
          <!--end::Nav item-->
          <!--begin::Nav item-->
          <li class="nav-item mt-2">
            <a
              class="nav-link text-active-primary ms-0 me-10 py-5"
              :class="{
                active: currentTab === 'pixels'
              }"
              href="#"
              @click.prevent="changeTab('pixels')"
            >
              Pixels
            </a>
          </li>
          <!--end::Nav item-->
          <!--begin::Nav item-->
          <li class="nav-item mt-2">
            <a
              class="nav-link text-active-primary ms-0 me-10 py-5"
              :class="{
                active: currentTab === 'packages'
              }"
              href="#"
              @click.prevent="changeTab('packages')"
            >
              Grupos de Estratégias
            </a>
          </li>
          <!--end::Nav item-->
          <!--begin::Nav item-->
          <li class="nav-item mt-2">
            <a
              class="nav-link text-active-primary ms-0 me-10 py-5"
              :class="{
                active: currentTab === 'goals'
              }"
              href="#"
              @click.prevent="changeTab('goals')"
            >
              Metas
            </a>
          </li>
          <!--end::Nav item-->
          <!--begin::Nav item-->
          <li class="nav-item mt-2">
            <a
              class="nav-link text-active-primary ms-0 me-10 py-5"
              :class="{
                active: currentTab === 'watchers'
              }"
              href="#"
              @click.prevent="changeTab('watchers')"
            >
              Watchers
            </a>
          </li>
          <!--end::Nav item-->
          <!--begin::Nav item-->
          <li class="nav-item mt-2">
            <a
              class="nav-link text-active-primary ms-0 me-10 py-5"
              :class="{
                active: currentTab === 'wallets'
              }"
              href="#"
              @click.prevent="changeTab('wallets')"
            >
              Histórico de transações
            </a>
          </li>
          <!--end::Nav item-->
        </ul>
        <!--begin::Navs-->
      </div>
    </div>
    <!--end::Navbar-->

    <!-- DETALHES TAB -->
    <!--begin::details View-->
    <div class="card mb-5 mb-xl-10" v-show="currentTab === 'details'">
      <!--begin::Card header-->
      <div class="card-header cursor-pointer">
        <!--begin::Card title-->
        <div class="card-title m-0">
          <h3 class="fw-bold m-0">Detalhes</h3>
        </div>
        <!--end::Card title-->
        <!--begin::Action-->
        <!--end::Action-->
      </div>
      <!--begin::Card header-->
      <!--begin::Card body-->
      <div class="card-body p-9">
        <template>
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">ID</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.id }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">ID sequencial</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.ref_id }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Nome</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.name }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Tipo</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.type | formatCampaignType }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Anunciante</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">
                <router-link
                  :to="{ name: 'advertisers.show', params: { id: campaign.advertiser.id }}"
                >
                  {{ campaign.advertiser.name }}
                </router-link>
              </span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Data de início</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.start_date | formatDate('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Data de término</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.end_date | formatDate('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Moeda</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.advertiser.currency | formatCurrencyType }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Taxa de câmbio</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.exchange_rate_amount / 100 | formatMoney }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Valor</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.amount/100 | formatMoney(campaign.advertiser.currency) }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Valor gasto</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.spending/100 | formatMoney(campaign.advertiser.currency) }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Valor disponível</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.available_amount/100 | formatMoney(campaign.advertiser.currency) }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Status</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.status | formatStatus }}</span>
              <ul v-if="campaignAuditLogs.length > 0">
                <li v-for="(log, index) in campaignAuditLogs" :key="index">Manualmente alterado: {{ log.user_name }} - {{ log.created_at }}</li>
              </ul>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Plataforma</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.platform }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7" v-if="campaign.platform === 'MANUAL'">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Planilha de resultados</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">
                <a :href="`https://docs.google.com/spreadsheets/d/${campaign.spreadsheet_id}/edit`" target="_blank">Clique aqui</a>
              </span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">ID na Plataforma</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.platform_id }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Impressões</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.impressions }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Cliques</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.clicks }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Conversões</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.conversions }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">CTR</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.ctr }}%</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">CPM</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.cpm/100 | formatMoney(campaign.advertiser.currency) }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">CPA</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.cpa/100 | formatMoney(campaign.advertiser.currency) }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Permitido apenas visualização para o usuário?</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.is_read_only ? 'Sim' : 'Não' }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Retenção</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign?.retention ? campaign?.retention : 0 }}%</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Data de criação</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.created_at | formatDate('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Data de última atualização</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.updated_at | formatDate('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!-- Retention -->
          <div class="mb-10" v-if="campaign.platform === 'GOOGLE' && !campaign.is_read_only && campaign.status !== 'FINISHED'">
            <UpdateRetentionForm
              :campaign="campaign"
              @update="reset()"
            />
          </div>
          <!-- end Retention -->
          <!--begin::Input group-->
          <div class="row mb-7" v-if="campaign.monday_id">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Link para o Monday</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6"><a :href="'https://adsplay-midia.monday.com/boards/10023395495/pulses/' + campaign.monday_id" target="_blank" rel="noopener noreferrer">{{ 'https://adsplay-midia.monday.com/boards/10023395495/pulses/' + campaign.monday_id }}</a></span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <div class="text-center my-5" v-if="campaign.is_manual">
            <router-link class="btn btn-primary" :to="{ name: 'campaigns.edit', params: { id: campaign.id } }">Editar campanha</router-link>
          </div>
          <div class="d-flex flex-column flex-lg-row">
            <!-- SYNCHRONIZE CAMPAIGN -->
            <div class="col-12 col-lg-5 mb-7">
              <h3 class="m-0 text-gray-900 flex-grow-1">Sincronizar campanha com DV360</h3>
              <div class="mt-5">
                <SyncCampaignDv360Button
                  :campaign="baseCampaign"
                />
              </div>
            </div>
            <!-- END SYNCHRONIZE CAMPAIGN -->
            <!-- IMPERSONATE -->
            <div class="col-12 col-lg-3 mb-7" v-if="campaign.type !== 'META_ADS'">
              <h3 class="m-0 text-gray-900 flex-grow-1">Impersonate</h3>
              <div class="mt-5">
                <ImpersonateButton
                  :userId="campaign.user_impersonate_id"
                />
              </div>
            </div> <!-- END IMPERSONATE -->
            <!-- END CAMPAIGN -->
            <div class="col-12 col-lg-3 mb-7">
              <h3 class="m-0 text-gray-900 flex-grow-1">Encerrar Campanha</h3>
              <div class="mt-5">
                <EndCampaignButton
                  :campaign="baseCampaign"
                  @ended="handleEndedCampaign"
                  @error="handleEndCampaignError"
                />
              </div>
            </div>
            <!-- END END CAMPAIGN -->
          </div>
        </template>
      </div>
      <!--end::Card body-->
    </div>
    <!--end::details View--> <!-- END DETAILS TAB -->

    <!-- PIXELS TAB -->
    <!--begin::details View-->
    <div class="card mb-5 mb-xl-10" v-show="currentTab === 'pixels'">
      <!--begin::Card header-->
      <div class="card-header cursor-pointer">
        <!--begin::Card title-->
        <div class="card-title m-0">
          <h3 class="fw-bold m-0">Detalhes</h3>
        </div>
        <!--end::Card title-->
        <!--begin::Action-->
        <!--end::Action-->
      </div>
      <!--begin::Card header-->
      <!--begin::Card body-->
      <div class="card-body p-9">
        <template>
          <div class="table-responsive">
            <!--begin::Table-->
            <table class="table align-middle table-row-dashed fs-6 gy-5">
              <!--begin::Table head-->
              <thead>
                <!--begin::Table row-->
                <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                  <th class="min-w-100px">Nome do pixel</th>
                  <th class="min-w-70px">Nome da regra</th>
                  <th class="min-w-100px">Objetivo</th>
                  <th class="min-w-70px">Nome do evento</th>
                  <th class="min-w-70px">Status</th>
                </tr>
                <!--end::Table row-->
              </thead>
              <!--end::Table head-->
              <!--begin::Table body-->
              <tbody class="fw-semibold text-gray-600">
                <!--begin::Table row-->
                <tr v-for="(pixel, index) in campaign.pixels" :key="index">
                  <td>
                    <span>{{ pixel.pixel.name }}</span>
                  </td>
                  <td>
                    <span>{{ pixel.name }}</span>
                  </td>
                  <td>
                    <span>{{ pixel.objective }}</span>
                  </td>
                  <td>
                    <span>{{ pixel.event_name }}</span>
                  </td>
                  <td>
                    <span>{{ pixel.status | formatStatus }}</span>
                  </td>
                </tr>
                <!--end::Table row-->
              </tbody>
              <!--end::Table body-->
            </table>
          </div>
          <!--end::Table-->
        </template>
      </div>
      <!--end::Card body-->
    </div>
    <!--end::details View--> <!-- END PIXELS TAB -->

    <!-- PACKAGES -->
    <template v-if="currentTab === 'packages' && campaign">
      <!--begin::Navbar-->
      <div class="card mb-5 mb-xl-10" id="packages">
        <div class="card-body pt-0 pb-0">
          <!--begin::Navs-->
          <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
            <!--begin::Nav item-->
            <li class="nav-item mt-2" v-for="(pack, index) in campaign.packages" :key="index">
              <a
                class="nav-link text-active-primary ms-0 me-10 py-5"
                :class="{
                  active: currentPackageTab === index
                }"
                href="#"
                @click.prevent="changePackageTab(index)"
              >
                {{ pack.name }}
              </a>
            </li>
            <!--end::Nav item-->
          </ul>
          <!--begin::Navs-->
        </div>
      </div>
      <!--end::Navbar-->

      <!-- PACKAGES INFO -->
      <div>
        <div
          v-for="(pack, index) in campaign.packages" :key="index"
          v-show="currentPackageTab === index"
        >
          <!--begin::details View-->
          <div class="card mb-5 mb-xl-10">
            <!--begin::Card header-->
            <div class="card-header cursor-pointer">
              <!--begin::Card title-->
              <div class="card-title m-0">
                <h3 class="fw-bold m-0">Dados gerais</h3>
              </div>
              <!--end::Card title-->
              <!--begin::Action-->
              <!--end::Action-->
            </div>
            <!--begin::Card header-->
            <!--begin::Card body-->
            <div class="card-body p-9">
              <!--begin::Input group-->
              <div class="row mb-7">
                <!--begin::Label-->
                <label class="col-lg-4 fw-semibold text-muted">ID</label>
                <!--end::Label-->
                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <span class="fw-semibold text-gray-800 fs-6">{{ pack.id }}</span>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="row mb-7">
                <!--begin::Label-->
                <label class="col-lg-4 fw-semibold text-muted">Nome</label>
                <!--end::Label-->
                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <span class="fw-semibold text-gray-800 fs-6">{{ pack.name }}</span>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="row mb-7">
                <!--begin::Label-->
                <label class="col-lg-4 fw-semibold text-muted">Data de início</label>
                <!--end::Label-->
                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <span class="fw-semibold text-gray-800 fs-6">{{ pack.start_date | formatDate('DD/MM/YYYY HH:mm:ss') }}</span>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="row mb-7">
                <!--begin::Label-->
                <label class="col-lg-4 fw-semibold text-muted">Data de término</label>
                <!--end::Label-->
                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <span class="fw-semibold text-gray-800 fs-6">{{ pack.end_date | formatDate('DD/MM/YYYY HH:mm:ss') }}</span>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="row mb-7">
                <!--begin::Label-->
                <label class="col-lg-4 fw-semibold text-muted">Valor</label>
                <!--end::Label-->
                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <span class="fw-semibold text-gray-800 fs-6">{{ pack.amount/100 | formatMoney(campaign.advertiser.currency) }}</span>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="row mb-7">
                <!--begin::Label-->
                <label class="col-lg-4 fw-semibold text-muted">Valor gasto</label>
                <!--end::Label-->
                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <span class="fw-semibold text-gray-800 fs-6">{{ pack.spending/100 | formatMoney(campaign.advertiser.currency) }}</span>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="row mb-7">
                <!--begin::Label-->
                <label class="col-lg-4 fw-semibold text-muted">Valor disponível</label>
                <!--end::Label-->
                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <span class="fw-semibold text-gray-800 fs-6">{{ (pack.amount - pack.spending)/100 | formatMoney(campaign.advertiser.currency) }}</span>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="row mb-7">
                <!--begin::Label-->
                <label class="col-lg-4 fw-semibold text-muted">Meta de CPM</label>
                <!--end::Label-->
                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <span class="fw-semibold text-gray-800 fs-6">{{ pack.cpm_target_amount / 100 | formatMoney(campaign.advertiser.currency) }}</span>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="row mb-7">
                <!--begin::Label-->
                <label class="col-lg-4 fw-semibold text-muted">Meta de CPC</label>
                <!--end::Label-->
                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <span class="fw-semibold text-gray-800 fs-6">{{ pack.cpc_target_amount / 100 | formatMoney(campaign.advertiser.currency) }}</span>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="row mb-7">
                <!--begin::Label-->
                <label class="col-lg-4 fw-semibold text-muted">Status</label>
                <!--end::Label-->
                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <span class="fw-semibold text-gray-800 fs-6">{{ pack.status | formatStatus }}</span>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="row mb-7">
                <!--begin::Label-->
                <label class="col-lg-4 fw-semibold text-muted">Plataforma</label>
                <!--end::Label-->
                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <span class="fw-semibold text-gray-800 fs-6">{{ pack.platform }}</span>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="row mb-7">
                <!--begin::Label-->
                <label class="col-lg-4 fw-semibold text-muted">ID na Plataforma</label>
                <!--end::Label-->
                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <span class="fw-semibold text-gray-800 fs-6">{{ pack.platform_id }}</span>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="row mb-7">
                <!--begin::Label-->
                <label class="col-lg-4 fw-semibold text-muted">Impressões</label>
                <!--end::Label-->
                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <span class="fw-semibold text-gray-800 fs-6">{{ pack.impressions }}</span>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="row mb-7">
                <!--begin::Label-->
                <label class="col-lg-4 fw-semibold text-muted">Cliques</label>
                <!--end::Label-->
                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <span class="fw-semibold text-gray-800 fs-6">{{ pack.clicks }}</span>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="row mb-7">
                <!--begin::Label-->
                <label class="col-lg-4 fw-semibold text-muted">Conversões</label>
                <!--end::Label-->
                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <span class="fw-semibold text-gray-800 fs-6">{{ pack.conversions }}</span>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="row mb-7">
                <!--begin::Label-->
                <label class="col-lg-4 fw-semibold text-muted">CTR</label>
                <!--end::Label-->
                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <span class="fw-semibold text-gray-800 fs-6">{{ pack.ctr }}%</span>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="row mb-7">
                <!--begin::Label-->
                <label class="col-lg-4 fw-semibold text-muted">CPM</label>
                <!--end::Label-->
                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <span class="fw-semibold text-gray-800 fs-6">{{ pack.cpm/100 | formatMoney(campaign.advertiser.currency) }}</span>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="row mb-7">
                <!--begin::Label-->
                <label class="col-lg-4 fw-semibold text-muted">CPA</label>
                <!--end::Label-->
                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <span class="fw-semibold text-gray-800 fs-6">{{ pack.cpa/100 | formatMoney(campaign.advertiser.currency) }}</span>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="row mb-7">
                <!--begin::Label-->
                <label class="col-lg-4 fw-semibold text-muted">Data de criação</label>
                <!--end::Label-->
                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <span class="fw-semibold text-gray-800 fs-6">{{ pack.created_at | formatDate('DD/MM/YYYY HH:mm:ss') }}</span>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="row mb-7">
                <!--begin::Label-->
                <label class="col-lg-4 fw-semibold text-muted">Data de última atualização</label>
                <!--end::Label-->
                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <span class="fw-semibold text-gray-800 fs-6">{{ pack.updated_at | formatDate('DD/MM/YYYY HH:mm:ss') }}</span>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->
            </div>
            <!--end::Card body-->
          </div>
          <!--end::details View-->
          <!-- LINES -->
          <div class="mt-4">
            <h2 class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Estratégias</h2>
            <!-- LINES TABS -->
            <div class="mt-5">
              <!--begin::Navbar-->
              <div class="card mb-5 mb-xl-10">
                <div class="card-body pt-0 pb-0">
                  <!--begin::Navs-->
                  <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
                    <!--begin::Nav item-->
                    <li class="nav-item mt-2" v-for="(line, lIndex) in pack.lines" :key="lIndex">
                      <a
                        class="nav-link text-active-primary ms-0 me-10 py-5"
                        :class="{
                          active: currentLineTab === lIndex
                        }"
                        href="#"
                        @click.prevent="changeLineTab(lIndex)"
                      >
                        <span :title="line.name">{{ line.name.length > 30 ? `${line.name.substring(0,30)}...` : line.name }}</span>
                      </a>
                    </li>
                    <!--end::Nav item-->
                  </ul>
                  <!--begin::Navs-->
                </div>
              </div>
              <!--end::Navbar-->
            </div> <!-- LINES TABS -->

            <!-- LINES CONTENT -->
            <div
              v-for="(line, index) in pack.lines" :key="index"
              v-show="currentLineTab === index"
              :id="currentLineTab === index ? 'campaign_line' : null"
            >
              <!--begin::details View-->
              <div class="card mb-5 mb-xl-10">
                <!--begin::Card header-->
                <div class="card-header cursor-pointer">
                  <!--begin::Card title-->
                  <div class="card-title m-0">
                    <h3 class="fw-bold m-0">Dados gerais</h3>
                  </div>
                  <!--end::Card title-->
                  <!--begin::Action-->
                  <!--end::Action-->
                </div>
                <!--begin::Card header-->
                <!--begin::Card body-->
                <div class="card-body p-9">
                  <!--begin::Input group-->
                  <div class="row mb-7">
                    <!--begin::Label-->
                    <label class="col-lg-4 fw-semibold text-muted">ID</label>
                    <!--end::Label-->
                    <!--begin::Col-->
                    <div class="col-lg-8 fv-row">
                      <span class="fw-semibold text-gray-800 fs-6">{{ line.id }}</span>
                    </div>
                    <!--end::Col-->
                  </div>
                  <!--end::Input group-->
                  <!--begin::Input group-->
                  <div class="row mb-7">
                    <!--begin::Label-->
                    <label class="col-lg-4 fw-semibold text-muted">Nome</label>
                    <!--end::Label-->
                    <!--begin::Col-->
                    <div class="col-lg-8 fv-row">
                      <span class="fw-semibold text-gray-800 fs-6">{{ line.name }}</span>
                    </div>
                    <!--end::Col-->
                  </div>
                  <!--end::Input group-->
                  <!--begin::Input group-->
                  <div class="row mb-7">
                    <!--begin::Label-->
                    <label class="col-lg-4 fw-semibold text-muted">Tipo de estratégia</label>
                    <!--end::Label-->
                    <!--begin::Col-->
                    <div class="col-lg-8 fv-row">
                      <span class="fw-semibold text-gray-800 fs-6">{{ line.type | formatCreativeFormat }}</span>
                    </div>
                    <!--end::Col-->
                  </div>
                  <!--end::Input group-->
                  <!--begin::Input group-->
                  <div class="row mb-7">
                    <!--begin::Label-->
                    <label class="col-lg-4 fw-semibold text-muted">Valor gasto</label>
                    <!--end::Label-->
                    <!--begin::Col-->
                    <div class="col-lg-8 fv-row">
                      <span class="fw-semibold text-gray-800 fs-6">{{ line.spending/100 | formatMoney(campaign.advertiser.currency) }}</span>
                    </div>
                    <!--end::Col-->
                  </div>
                  <!--end::Input group-->
                  <!--begin::Input group-->
                  <div class="row mb-7">
                    <!--begin::Label-->
                    <label class="col-lg-4 fw-semibold text-muted">Status</label>
                    <!--end::Label-->
                    <!--begin::Col-->
                    <div class="col-lg-8 fv-row">
                      <span class="fw-semibold text-gray-800 fs-6">{{ line.status | formatStatus }}</span>
                    </div>
                    <!--end::Col-->
                  </div>
                  <!--end::Input group-->
                  <!--begin::Input group-->
                  <div class="row mb-7">
                    <!--begin::Label-->
                    <label class="col-lg-4 fw-semibold text-muted">Plataforma</label>
                    <!--end::Label-->
                    <!--begin::Col-->
                    <div class="col-lg-8 fv-row">
                      <span class="fw-semibold text-gray-800 fs-6">{{ line.platform }}</span>
                    </div>
                    <!--end::Col-->
                  </div>
                  <!--end::Input group-->
                  <!--begin::Input group-->
                  <div class="row mb-7">
                    <!--begin::Label-->
                    <label class="col-lg-4 fw-semibold text-muted">ID na Plataforma</label>
                    <!--end::Label-->
                    <!--begin::Col-->
                    <div class="col-lg-8 fv-row">
                      <span class="fw-semibold text-gray-800 fs-6">{{ line.platform_id }}</span>
                    </div>
                    <!--end::Col-->
                  </div>
                  <!--end::Input group-->
                  <!--begin::Input group-->
                  <div class="row mb-7">
                    <!--begin::Label-->
                    <label class="col-lg-4 fw-semibold text-muted">Impressões</label>
                    <!--end::Label-->
                    <!--begin::Col-->
                    <div class="col-lg-8 fv-row">
                      <span class="fw-semibold text-gray-800 fs-6">{{ line.impressions }}</span>
                    </div>
                    <!--end::Col-->
                  </div>
                  <!--end::Input group-->
                  <!--begin::Input group-->
                  <div class="row mb-7">
                    <!--begin::Label-->
                    <label class="col-lg-4 fw-semibold text-muted">Cliques</label>
                    <!--end::Label-->
                    <!--begin::Col-->
                    <div class="col-lg-8 fv-row">
                      <span class="fw-semibold text-gray-800 fs-6">{{ pack.clicks }}</span>
                    </div>
                    <!--end::Col-->
                  </div>
                  <!--end::Input group-->
                  <!--begin::Input group-->
                  <div class="row mb-7">
                    <!--begin::Label-->
                    <label class="col-lg-4 fw-semibold text-muted">Conversões</label>
                    <!--end::Label-->
                    <!--begin::Col-->
                    <div class="col-lg-8 fv-row">
                      <span class="fw-semibold text-gray-800 fs-6">{{ line.conversions }}</span>
                    </div>
                    <!--end::Col-->
                  </div>
                  <!--end::Input group-->
                  <!--begin::Input group-->
                  <div class="row mb-7">
                    <!--begin::Label-->
                    <label class="col-lg-4 fw-semibold text-muted">CTR</label>
                    <!--end::Label-->
                    <!--begin::Col-->
                    <div class="col-lg-8 fv-row">
                      <span class="fw-semibold text-gray-800 fs-6">{{ line.ctr }}%</span>
                    </div>
                    <!--end::Col-->
                  </div>
                  <!--end::Input group-->
                  <!--begin::Input group-->
                  <div class="row mb-7">
                    <!--begin::Label-->
                    <label class="col-lg-4 fw-semibold text-muted">CPM</label>
                    <!--end::Label-->
                    <!--begin::Col-->
                    <div class="col-lg-8 fv-row">
                      <span class="fw-semibold text-gray-800 fs-6">{{ line.cpm/100 | formatMoney(campaign.advertiser.currency) }}</span>
                    </div>
                    <!--end::Col-->
                  </div>
                  <!--end::Input group-->
                  <!--begin::Input group-->
                  <div class="row mb-7">
                    <!--begin::Label-->
                    <label class="col-lg-4 fw-semibold text-muted">CPA</label>
                    <!--end::Label-->
                    <!--begin::Col-->
                    <div class="col-lg-8 fv-row">
                      <span class="fw-semibold text-gray-800 fs-6">{{ line.cpa/100 | formatMoney(campaign.advertiser.currency) }}</span>
                    </div>
                    <!--end::Col-->
                  </div>
                  <!--end::Input group-->
                  <!--begin::Input group-->
                  <div class="row mb-7">
                    <!--begin::Label-->
                    <label class="col-lg-4 fw-semibold text-muted">Data de criação</label>
                    <!--end::Label-->
                    <!--begin::Col-->
                    <div class="col-lg-8 fv-row">
                      <span class="fw-semibold text-gray-800 fs-6">{{ line.created_at | formatDate('DD/MM/YYYY HH:mm:ss') }}</span>
                    </div>
                    <!--end::Col-->
                  </div>
                  <!--end::Input group-->
                  <!--begin::Input group-->
                  <div class="row mb-7">
                    <!--begin::Label-->
                    <label class="col-lg-4 fw-semibold text-muted">Data de última atualização</label>
                    <!--end::Label-->
                    <!--begin::Col-->
                    <div class="col-lg-8 fv-row">
                      <span class="fw-semibold text-gray-800 fs-6">{{ line.updated_at | formatDate('DD/MM/YYYY HH:mm:ss') }}</span>
                    </div>
                    <!--end::Col-->
                  </div>
                  <!--end::Input group-->
                </div>
                <!--end::Card body-->
              </div>
              <!--end::details View-->

              <!--begin::details View-->
              <div class="card mb-5 mb-xl-10">
                <!--begin::Card header-->
                <div class="card-header cursor-pointer">
                  <!--begin::Card title-->
                  <div class="card-title m-0">
                    <h3 class="fw-bold m-0">Criativos</h3>
                  </div>
                  <!--end::Card title-->
                  <!--begin::Action-->
                  <!--end::Action-->
                </div>
                <!--begin::Card header-->
                <!--begin::Card body-->
                <div class="card-body p-9">
                  <CreativeListTable
                    :creatives="line.creatives"
                  />
                </div>
                <!--end::Card body-->
              </div>
              <!--end::details View-->

              <!--begin::details View-->
              <div class="card mb-5 mb-xl-10">
                <!--begin::Card header-->
                <div class="card-header cursor-pointer">
                  <!--begin::Card title-->
                  <div class="card-title m-0">
                    <h3 class="fw-bold m-0">Targeting</h3>
                  </div>
                  <!--end::Card title-->
                  <!--begin::Action-->
                  <!--end::Action-->
                </div>
                <!--begin::Card header-->
                <!--begin::Card body-->
                <div class="card-body p-9">
                  <div class="mb-5">
                    <h4 class="fw-bold m-0 mb-3">Audiências</h4>
                    <template v-if="line.audiences.length > 0">
                      <ul class="mb-0">
                        <li
                          v-for="(audience, i) in line.audiences"
                          :key="i"
                        >
                          {{ audience.name }}
                        </li>
                      </ul>
                    </template>
                    <template v-else>
                      <p>Sem audiências selecionadas</p>
                    </template>
                  </div>
                  <div class="mb-5">
                    <template v-if="campaign.packages[0].lines[0].marker_locations.length > 0">
                      <h5 class="fw-bold m-0 mb-5">
                        <span>Localizações por raio</span>
                      </h5>
                      <ul>
                        <li v-for="(marker_location, index) in campaign.packages[0].lines[0].marker_locations" :key="index">
                          <span>{{marker_location.name}} - Raio: {{ marker_location.radius }} km - Latitude: {{ marker_location?.lat}} - Longitude: {{ marker_location.lng }}</span>
                        </li>
                      </ul>
                    </template>
                    <h5 class="fw-bold m-0 mb-5">
                      <span>Estados</span>
                    </h5>
                    <template v-if="line.states.length > 0">
                      <ul class="mb-0">
                        <li
                          v-for="(state, i) in line.states"
                          :key="i"
                        >
                          {{ state.name }}
                        </li>
                      </ul>
                    </template>
                    <template v-else>
                      <p>Sem estados selecionados</p>
                    </template>
                    <h5 class="fw-bold my-5">
                      <span>Cidades</span>
                    </h5>
                    <template v-if="line.cities.length > 0">
                      <ul class="mb-0">
                        <li
                          v-for="(city, i) in line.cities"
                          :key="i"
                        >
                          {{ city.name }} ({{ city.state_short_name }})
                        </li>
                      </ul>
                    </template>
                    <template v-else>
                      <p>Sem cidades selecionadas</p>
                    </template>
                  </div>
                  <div class="mb-5 d-flex">
                    <div class="col-3">
                      <h4 class="fw-bold m-0 mb-5">Gênero</h4>
                      <template v-if="Object.keys(line.demographics).length > 0
                                            && line.demographics.gender.length > 0">
                        <ul class="mb-0">
                          <li
                            v-for="(gender, index) in line.demographics.gender"
                            :key="index"
                          >
                            {{ gender }}
                          </li>
                        </ul>
                      </template>
                      <template v-else>
                        <p>Não informado</p>
                      </template>
                    </div>
                    <div class="col-3">
                      <h4 class="fw-bold m-0 mb-5">Idade</h4>
                      <template v-if="Object.keys(line.demographics).length > 0
                                          && line.demographics.age.length > 0">
                        <p class="mb-0">{{ line.demographics.age[0] }} até
                          {{ line.demographics.age[1] }} anos
                        </p>
                        <p v-if="line.demographics.age[2]" class="mb-0">
                          Desconhecido
                        </p>
                      </template>
                      <template v-else>
                        <p>Não informado</p>
                      </template>
                    </div>
                  </div>
                  <div class="mb-5 d-flex">
                    <div class="col-3">
                      <h4 class="fw-bold m-0 mb-5">Browsers</h4>
                      <template v-if="line.browser.length > 0">
                        <ul class="mb-0">
                          <li
                            v-for="(browser, i) in line.browser"
                            :key="i"
                          >
                            {{ browser }}
                          </li>
                        </ul>
                      </template>
                      <template v-else>
                        <p>Sem browsers selecionados</p>
                      </template>
                    </div>
                    <div class="col-3">
                      <h4 class="fw-bold m-0 mb-5">Environment</h4>
                      <template v-if="line.environment.length > 0">
                        <ul class="mb-0">
                          <li
                            v-for="(environment, i) in line.environment"
                            :key="i"
                          >
                            {{ environment }}
                          </li>
                        </ul>
                      </template>
                      <template v-else>
                        <p>Sem environments selecionados</p>
                      </template>
                    </div>
                  </div>
                  <div class="mb-5">
                    <h4 class="fw-bold m-0 mb-5">Keywords</h4>
                    <template v-if="line.keywords.length > 0">
                      <ul class="mb-0">
                        <li
                          v-for="(keyword, index) in line.keywords"
                          :key="index"
                        >
                          {{ keyword.text }}
                        </li>
                      </ul>
                    </template>
                    <template v-else>
                      <p>Sem keywords adicionadas</p>
                    </template>
                  </div>
                  <div class="mb-5">
                    <h4 class="fw-bold m-0 mb-5">Categorias</h4>
                    <template v-if="line.categories.length > 0">
                      <ul class="mb-0">
                        <li
                          v-for="(category, index) in line.categories"
                          :key="index"
                        >
                          {{ category.name }}
                        </li>
                      </ul>
                    </template>
                    <template v-else>
                      <p>Sem categorias selecionadas</p>
                    </template>
                  </div>
                  <div class="mb-5">
                    <h4 class="fw-bold m-0 mb-5">Audiências customizadas</h4>
                    <template v-if="line.custom_audiences.length > 0">
                      <ul class="mb-0">
                        <li
                          v-for="(audience, i) in line.custom_audiences"
                          :key="i"
                        >
                          {{ audience.name }}
                        </li>
                      </ul>
                    </template>
                    <template v-else>
                      <p>Sem audiências customizadas selecionadas</p>
                    </template>
                  </div>
                  <div class="mb-5">
                    <h4 class="fw-bold m-0 mb-5">Blocklist</h4>
                    <template v-if="line.blacklist.length > 0">
                      <ul class="mb-0">
                        <li
                          v-for="(item, i) in line.blacklist"
                          :key="i"
                        >
                          {{ item.name }}
                        </li>
                      </ul>
                    </template>
                    <template v-else>
                      <p>Sem blocklist selecionada</p>
                    </template>
                  </div>
                  <div class="mb-5">
                    <h4 class="fw-bold m-0 mb-5">Wishlist</h4>
                    <template v-if="line.wishlist.length > 0">
                      <ul class="mb-0">
                        <li
                          v-for="(item, i) in line.wishlist"
                          :key="i"
                        >
                          {{ item.name }}
                        </li>
                      </ul>
                    </template>
                    <template v-else>
                      <p>Sem wishlist selecionada</p>
                    </template>
                  </div>
                  <div class="mb-5">
                    <h4 class="fw-bold m-0 mb-5">Frequency cap</h4>
                    <span v-if="line.frequency_cap.type === 'UNLIMITED'">Sem limite</span>
                    <span v-else>
                      Limitar frequência a {{ line.frequency_cap.max_impressions }} impressões por
                      {{ line.frequency_cap.time_unit_count }}
                      {{
                        {
                          MINUTES: 'minutos',
                          HOURS: 'horas',
                          DAYS: 'dias',
                          WEEKS: 'semanas',
                          MONTHS: 'mês'
                        }[line.frequency_cap.time_unit] || ''
                      }}
                    </span>
                  </div>
                </div>
                <!--end::Card body-->
              </div>
              <!--end::details View-->

            </div><!-- END LINES CONTENT -->

          </div> <!-- END LINES -->
        </div>
      </div> <!-- END PACKAGES INFO -->
    </template> <!-- END PACKAGES -->

    <!-- GOALS TAB -->
    <!--begin::details View-->
    <div class="card mb-5 mb-xl-10" v-show="currentTab === 'goals'">
      <!--begin::Card header-->
      <div class="card-header cursor-pointer">
        <!--begin::Card title-->
        <div class="card-title m-0">
          <h3 class="fw-bold m-0">Metas</h3>
        </div>
        <!--end::Card title-->
        <!--begin::Action-->
        <!--end::Action-->
      </div>
      <!--begin::Card header-->
      <!--begin::Card body-->
      <div class="card-body p-9">
        <template>
          <div>
            <CampaignGoalListTable
              :campaignId="campaign.id"
              :reload="reloadGoalsAndWatchers"
            />
          </div>
          <div class="d-flex flex-column flex-sm-row mt-5 justify-content-center gap-3">
            <!-- Edit -->
            <Button
              class="btn btn-primary"
              v-b-modal="'upsert-campaign-goal'"
            >
              Criar meta
            </Button><!-- Edit -->
          </div>
          <UpsertCampaignGoalModal
            :campaignId="campaign.id"
            @upserted="handleUpsertedGoalAndWatchers"
          />
        </template>
      </div>
      <!--end::Card body-->
    </div>
    <!--end::details View--> <!-- END GOALS TAB -->

    <!-- WATCHERS TAB -->
    <!--begin::details View-->
    <div class="card mb-5 mb-xl-10" v-show="currentTab === 'watchers'">
      <!--begin::Card header-->
      <div class="card-header cursor-pointer">
        <!--begin::Card title-->
        <div class="card-title m-0">
          <h3 class="fw-bold m-0">Watchers</h3>
        </div>
        <!--end::Card title-->
        <!--begin::Action-->
        <!--end::Action-->
      </div>
      <!--begin::Card header-->
      <!--begin::Card body-->
      <div class="card-body p-9">
        <template>
          <div>
            <WatcherListTable
              :campaignId="campaign.id"
              :reload="reloadGoalsAndWatchers"
            />
          </div>
          <div class="d-flex flex-column flex-sm-row mt-3 justify-content-center gap-3">
            <!-- Edit -->
            <!-- <router-link
              :to="{ name: 'watchers.create', query: { campaign_id: campaign.id } }"
              class="btn btn-primary"
            >
              Criar watcher
            </router-link>Edit -->
          </div>
        </template>
      </div>
      <!--end::Card body-->
    </div>
    <!--end::details View--> <!-- END WATCHERS TAB -->

    <!-- WALLETS TAB -->
      <!--begin::details View-->
      <div class="card mb-5 mb-xl-10" v-show="currentTab === 'wallets'">
        <!--begin::Card header-->
        <div class="card-header cursor-pointer">
          <!--begin::Card title-->
          <div class="card-title m-0">
            <h3 class="fw-bold m-0">Histórico de transações</h3>
          </div>
          <!--end::Card title-->
          <!--begin::Action-->
          <!--end::Action-->
        </div>
        <!--begin::Card header-->
        <!--begin::Card body-->
        <div class="card-body p-9" v-if="campaign">
          <WalletListTable
            :campaignId="campaign.id"
            :currency="campaign.advertiser.currency"
          />
        </div>
        <!--end::Card body-->
      </div>
      <!--end::details View--> <!-- END WALLETS TAB -->
    <!-- END CONTENT -->
  </div>
</template>

<script>

import LogsService from '@/modules/logs/services/logs-service'
import NotificationsService from '@/modules/notifications/services/notifications-service'

import CampaignGoalListTable from '@/components/campaign-goals/CampaignGoalListTable'
import CreativeListTable from '@/components/creatives/CreativeListTable'
import EndCampaignButton from '@/components/campaigns/EndCampaignButton'
import ImpersonateButton from '@/components/users/ImpersonateButton'
import SyncCampaignDv360Button from '@/components/campaigns/SyncCampaignDv360Button'
import UpsertCampaignGoalModal from '@/components/campaign-goals/UpsertCampaignGoalModal'
import WalletListTable from '@/components/wallets/WalletListTable'
import WatcherListTable from '@/components/watchers/WatcherListTable'
import UpdateRetentionForm from '@/components/campaigns/UpdateRetentionForm'

export default {
  props: ['baseCampaign'],
  components: {
    CampaignGoalListTable,
    CreativeListTable,
    EndCampaignButton,
    ImpersonateButton,
    UpdateRetentionForm,
    SyncCampaignDv360Button,
    UpsertCampaignGoalModal,
    WalletListTable,
    WatcherListTable
  },
  data () {
    return {
      campaign: '',
      campaignAuditLogs: [],
      currentLineTab: 0,
      currentPackageTab: 0,
      currentTab: 'details',
      loader: false,
      reloadGoalsAndWatchers: false
    }
  },
  created () {
    this.campaign = this.baseCampaign
    if (this.campaign.status === 'FINISHED') this.getCampaignAuditLogs()

    // Load pre-defined tab from query params
    const tab = this.$route.query.tab ?? null
    if (tab) this.changeTab(tab)
  },
  mounted () {
    //  Automatic scroll on page load if section query param is present
    this.$nextTick(() => {
      const section = this.$route.query.section
      if (section) {
        if (section === 'packages' || section === 'campaign_line') {
          this.currentTab = 'packages'
        }

        setTimeout(() => {
          this.scrollToSection(section)
        }, 500)
      }
    })
  },
  computed: {
    /**
     * Current tab title
     */
    tabTitle () {
      switch (this.currentTab) {
        case 'packages':
          return 'Grupos de Estratégias'
        default:
          return 'Detalhes'
      }
    }
  },
  methods: {
    /**
     * Change line tab
     */
    changeLineTab (tab) {
      this.currentLineTab = tab
      // Atualiza a URL com o índice da line
      this.$router.push({
        query: {
          ...this.$route.query,
          tab: 'packages',
          package: this.currentPackageTab,
          line: tab
        }
      }).catch(() => {}) // Ignora erro de navegação duplicada
    },
    /**
     * Change package tab and reset line tab
     */
    changePackageTab (tab) {
      this.currentPackageTab = tab
      this.currentLineTab = 0
      // Atualiza a URL com o índice do package
      this.$router.push({
        query: {
          ...this.$route.query,
          tab: 'packages',
          package: tab
        }
      }).catch(() => {}) // Ignora erro de navegação duplicada
    },
    /**
     * Change current tab
     */
    changeTab (tab) {
      this.currentTab = tab
      this.$router.push({
        query: {
          ...this.$route.query,
          tab
        }
      }).catch(() => {})
    },
    /**
     * Scroll to section
     */
    scrollToSection (sectionId) {
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }
    },
    /**
     * Get campaign audit logs
    */
    async getCampaignAuditLogs () {
      try {
        const logs = await LogsService.getActivityLogs({
          type: 'MANUALLY_END_CAMPAIGN',
          loggable_type: 'CAMPAIGN',
          loggable_id: this.baseCampaign.id
        })
        this.campaignAuditLogs = logs
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
    },
    /**
     * Handle error on campaign ending
    */
    handleEndCampaignError (error) {
      error.handleGlobally && error.handleGlobally()
    },
    /**
     * Handle ended campaign
     */
    handleEndedCampaign () {
      const notification = {
        notification: {
          type: 'success',
          content: 'Campanha encerrada com sucesso'
        }
      }
      NotificationsService.createGlobalSuccessNotification(notification)
      this.$emit('reload', this.baseCampaign)
    },
    /**
     * Handle upserted goal
    */
    handleUpsertedGoalAndWatchers (goal) {
      this.reloadGoalsAndWatchers = true
      setTimeout(() => {
        this.reloadGoalsAndWatchers = false
      }, 500)
    },
    /**
     * Reloads page
     */
    reset () {
      this.$emit('reload', this.baseCampaign)
    }
  }
}
</script>
